// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

const isProd = process.env.NODE_ENV === 'production'

function getSubdomain() {
    const parts = window.location.hostname.split('.')
    return parts.length > 2 ? parts[0] : null
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        document.getElementById('app').scrollIntoView({ behavior: 'smooth' })
    }
})

const routeContext = require.context('.', false, /routes\.js$/i)
let childrenRoutes = []
routeContext.keys().forEach(fileName => {
    const moduleRoutes = routeContext(fileName).default
    if (Array.isArray(moduleRoutes)) {
        childrenRoutes.push(...moduleRoutes)
    }
})

router.addRoute({
    meta: { public: true },
    path: '/' + process.env.VUE_APP_FRONT_URL_AGENDA_PRO,
    component: () => import('../../App'),
    children: childrenRoutes
})

router.addRoute({
    path: `/${process.env.VUE_APP_FRONT_URL_AGENDA_PRO}/sistema/acessar_erp`,
    redirect: '/inicio'
})

if (isProd) {
    router.beforeEach((to, from, next) => {
        const slug = getSubdomain()
        if (slug) {
            to.params.slug = slug
        }
        next()
    })
}

export default router
